import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {UsersService} from 'src/app/modules/shared/services/users.service';
import {Constants} from 'src/app/modules/shared/config/constants.config';
import {ThemeService} from '../../../shared/services/theme.service';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Router} from '@angular/router';
import {MasterProfileViewModel} from '../../../shared/viewModels/master.viewModel';
import {MasterService} from '../../../shared/services/master.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {RecipesFilterModalComponent} from '../../../recipes/components/recipes-filter/recipes-filter.component';
import {BsModalEventsEmitter} from '../../../shared/events/bsModal.events';
import {ProfilesCreateModalComponent} from '../profiles-create/profiles-create.component';
import {AuthService} from '../../../shared/services/auth.service';
import {UserProfileViewModel} from '../../../shared/viewModels/userProfile.viewModel';
import {ProfilesSendLoginModalComponent} from '../profiles-send-login/profiles-send-login.component';
import {ProfilesRecoveryModalComponent} from '../profiles-recovery/profiles-recovery.component';
import * as moment from 'moment/moment';

@Component({
    selector: 'app-master-profiles',
    templateUrl: './profiles.component.html',
    styleUrls: ['./profiles.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilesComponent implements OnInit {
    profiles: UserProfileViewModel[];
    email_sent_info = {};

    bsModalRef: BsModalRef;
    dtOptions: {};

    constructor(
        private readonly usersService: UsersService,
        private readonly masterService: MasterService,
        public readonly changeDetectorRef: ChangeDetectorRef,
        public readonly themeService: ThemeService,
        public readonly constants: Constants,
        public readonly router: Router,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly authService: AuthService,
    ) {
    }

    ngOnInit() {
        let lastPage = 0;
        let lastSearchText = '';
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 20,
            displayStart: lastPage, // Last Selected Page
            search: {search: lastSearchText}, // Last Searched Text
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                lastPage = dataTablesParameters.start;  // Note :  dataTablesParameters.start = page count * table length
                lastSearchText = dataTablesParameters.search.value;

                // this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

                this.masterService.getProfiles(dataTablesParameters.start, dataTablesParameters.length, dataTablesParameters.search.value).subscribe(profiles => {
                    // this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                    this.profiles = profiles.data;
                    this.email_sent_info = profiles.email_sent_info;

                    profiles.email_sent_info.forEach((item) => {
                        this.email_sent_info[item.user_id] = item.created_at;
                    });

                    callback({
                        recordsTotal: profiles.recordsTotal,
                        recordsFiltered: profiles.recordsFiltered,
                        data: []
                    });

                    this.changeDetectorRef.markForCheck();
                });

            },
            autoWidth: false,
            ordering: true,
            lengthMenu: ['5', '10', '20', '50', '100'],
            columns: [
                {data: 'id'},
                {
                    render: (data, type, full, meta) => {
                        return 'asd';
                    }
                },
                {data: 'first_name'},
                {data: 'email'},
                {data: 'email2'},
                {data: 'id'}
            ]
        };
    }

    getEmailSentInfo(userId: number) {
        if (!this.email_sent_info[userId]) {
            return '';
        }

        return this.email_sent_info[userId];
    }

    openCreateModal(e: Event) {
        e.stopPropagation();
        e.stopImmediatePropagation();

        this.bsModalRef = this.bsModalService.show(ProfilesCreateModalComponent, {
            backdrop: true
        });

        this.bsModalRef.content.profilesComponent = this;
        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    openRecoveryModal(e: Event) {
        e.stopPropagation();
        e.stopImmediatePropagation();

        this.bsModalRef = this.bsModalService.show(ProfilesRecoveryModalComponent, {
            backdrop: true
        });

        this.bsModalRef.content.profilesComponent = this;
        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    openUserMeals(id: number) {
        this.masterService.masterLogin(id).subscribe(token => {
            this.authService.setStorageItem('original_logged_token', this.authService.getJWT());
            this.authService.setStorageItem('master_sub_profile_logged_token', token.token);

            // this.authService.setJWT(this.authService.getStorageItem('master_sub_profile_logged_token'));

            this.router.navigate(['/master/meals', id]);
        });
    }

    openMessages(id: number) {
        this.router.navigate(['/master/messages', id]);
    }

    sendLoginDetails(profile: UserProfileViewModel) {
        this.bsModalRef = this.bsModalService.show(ProfilesSendLoginModalComponent, {
            backdrop: true
        });

        this.bsModalRef.content.profilesComponent = this;
        this.bsModalRef.content.profile = profile;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    changeMasterReadyProfile(profile: UserProfileViewModel, index: number) {
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.masterService
            .changeMasterReadyProfile(profile.id)
            .subscribe(response => {
                this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

                if (this.profiles[index].master_profile_status === 'NOT_READY') {
                    this.profiles[index].master_profile_status = 'PENDING';
                } else if (this.profiles[index].master_profile_status === 'PENDING') {
                    this.profiles[index].master_profile_status = 'READY';
                } else if (this.profiles[index].master_profile_status === 'READY') {
                    this.profiles[index].master_profile_status = 'NOT_READY';
                }

                this.changeDetectorRef.markForCheck();
            });
    }
}
